import React, { useEffect } from "react";
import { IcoAlert } from "./Icons";

function ConfirmDialog({
  title = "Xác nhận", icon, message, warning,
  confirmLabel = "Đồng ý", danger = true,
  onConfirm, onCancel,
}) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onCancel(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel]);

  return (
    <div className="modal" role="alertdialog" aria-modal="true" aria-label={title}>
      <div className="modal-card">
        <div className="modal-head">
          <span className={`modal-ico ${danger ? "danger" : ""}`}>{icon || <IcoAlert size={20} />}</span>
          <div>
            <h3>{title}</h3>
          </div>
        </div>

        <div className="modal-body">
          {warning && (
            <div className="callout warn">
              <IcoAlert size={16} />
              <span>{warning}</span>
            </div>
          )}
          <p className="modal-text pre-line">{message}</p>
        </div>

        <div className="modal-foot">
          <button className="btn btn-quiet" onClick={onCancel}>Hủy</button>
          <button className={`btn ${danger ? "btn-danger" : "btn-primary"}`} onClick={onConfirm} autoFocus>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
